export default __webpack_public_path__ + "static/media/D_Dedo.ae01a6ed.mp3";